import { VisaVignetteDocMap } from '../../../../../types';
import { getVisible } from '../../../../../utilities/documents';
import Finger, { Status } from '../../../../atoms/finger';
import ChecklistSection from '../../../../atoms/checklist-section';
import * as types from 'types';
import { checkIsArrival } from './helpers';

interface IProps {
  documents: VisaVignetteDocMap;
  travelStatus: types.ITravelStatusSection;
  openDocumentModal: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string,
    docKey: string,
    modalTitle: string,
    fileNames: string[],
    isComplete: boolean,
    biometricResidencePermit?: any
  ) => void;
}

export const StampedVisaVignetteDocs = (props: IProps) => {
  const { documents: docs, openDocumentModal, travelStatus } = props;

  if (!docs || Object.keys(docs).length === 0) {
    return null;
  }
  const visibleDocs = getVisible(docs, false);

  if (visibleDocs.length === 0) {
    return null;
  }

  const openModal = () => {
    openDocumentModal(
      'afterArrival',
      null,
      'stampedVisaVignette',
      docKey,
      'Stamped Student Visa Vignette',
      fileNames,
      isComplete
    );
  };

  let isComplete = false;
  let fileNames: string[] = [];
  let docKey = '';

  const isArrival = checkIsArrival({
    status: travelStatus.status,
    arrivalDate: travelStatus.arrivalDate
  });

  const renderedDocs = visibleDocs.map(({ item, key: visaVignetteKey }) => {
    docKey = visaVignetteKey;
    switch (item.status) {
      case 'REJECTED': {
        return (
          <Finger
            key={`stamped-visa-vignette-${visaVignetteKey}`}
            id={`stamped-visa-vignette-${visaVignetteKey}`}
            hideButton={true}
            status={Status.Rejected}
            reason={item.reason}
            label={'Stamped Student Visa Vignette'}
          />
        );
      }
      case 'APPROVED':
      case 'UPLOADED_OK':
      case 'REPLACED': {
        isComplete = true;
        fileNames = item.fileNames;

        return (
          <Finger
            key={`stamped-visa-vignette-${visaVignetteKey}`}
            id={`stamped-visa-vignette-${visaVignetteKey}`}
            status={Status.Complete}
            completeLabel={'Done'}
            label={'Stamped Student Visa Vignette'}
            onClick={openModal}
          />
        );
      }
      default: {
        return (
          <Finger
            key={`stamped-visa-vignette-${visaVignetteKey}`}
            id={`stamped-visa-vignette-${visaVignetteKey}`}
            status={isArrival ? Status.Waiting : Status.InProgress}
            completeLabel={'Done'}
            label={'Stamped Student Visa Vignette'}
            onClick={openModal}
          />
        );
      }
    }
  });

  return (
    <>
      <ChecklistSection label={`Upload your passport visa page with a UK border stamp.`} edit={openModal}>
        {renderedDocs}
      </ChecklistSection>
    </>
  );
};
